import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=a514b03a&scoped=true"
import script from "./Modules.vue?vue&type=script&lang=js"
export * from "./Modules.vue?vue&type=script&lang=js"
import style0 from "./Modules.vue?vue&type=style&index=0&id=a514b03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a514b03a",
  null
  
)

export default component.exports